module.exports = __webpack_public_path__ + "static/media/Drought.f6141bdb.jpg";